import React from 'react';
import { Col, DatePicker, Form, Input, Row, Select } from 'antd';
import InputLabel from 'components/InputLabel/index';
import dayjs from 'dayjs';

/**
 * GeneralLeaseInformation component renders the general lease information section
 * with form fields for the lease record management.
 *
 * This component should be rendered within a Form component context since it uses
 * Form.Item components that depend on the form context.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.screen - Current screen mode ('CREATE', 'EDIT', or 'VIEW')
 * @param {Object} props.constantFormValues - Form configuration values
 * @param {Object} props.statusData - Current status data of the lease (for non-CREATE screens)
 *
 * @returns {JSX.Element} The General Lease Information form section
 */
const GeneralLeaseInformation = ({ form, screen, constantFormValues, statusData }) => {
	const LeaseEndDate = dayjs().add(1, 'month');
	const handleLeaseDateChangeD = () => {
		const leaseStartDate = form.getFieldValue('leaseStartDate');
		const leaseTerm = form.getFieldValue('leaseTerm');

		if (leaseStartDate && leaseTerm) {
			const leaseEndDate = leaseStartDate.add(leaseTerm, 'month').subtract(1, 'day'); // Add 5 months

			form.setFieldsValue({
				leaseEndDate, // Updates leaseEndDate automatically
			});
		}

		if (leaseStartDate) {
			form.setFieldValue(['changes', 0, 'inputChangeEffectiveDate'], dayjs(leaseStartDate));
		}
	};

	const handleLeaseDateChange = () => {
		const leaseStartDate = form.getFieldValue('leaseStartDate');
		const leaseTerm = form.getFieldValue('leaseTerm');

		if (leaseStartDate && leaseTerm) {
			const leaseEndDate = leaseStartDate.add(leaseTerm, 'month').subtract(1, 'day'); // Add 5 months

			form.setFieldsValue({
				leaseEndDate, // Updates leaseEndDate automatically
			});
		}

		if (leaseStartDate) {
			form.setFieldValue(['changes', 0, 'inputChangeEffectiveDate'], dayjs(leaseStartDate));
		}
	};
	return (
		<Row gutter={[16, 0]} style={{ marginTop: '16px' }}>
			<Form.Item noStyle name={constantFormValues?.version?.key} />
			<Form.Item noStyle name={constantFormValues?.paymentModalitylabel?.key} />

			<Col xs={4}>
				<InputLabel label={constantFormValues?.LeaseId?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.LeaseId?.key}>
					<Input disabled placeholder="To be auto generated" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>
			<Col xs={4}>
				<InputLabel label={constantFormValues?.leaseStartDate?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.leaseStartDate?.key} rules={constantFormValues?.leaseStartDate?.rules}>
					<DatePicker
						disabled={screen === 'VIEW'}
						format="YYYY-MM-DD"
						style={{ width: '100%', height: '32px', borderRadius: '4px' }}
						onChange={handleLeaseDateChange}
					/>
				</Form.Item>
			</Col>

			{/* <Col xs={4}>
				<InputLabel label={constantFormValues?.leaseType?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.leaseType?.key} rules={constantFormValues?.leaseType?.rules}>
					<Select
						disabled={screen === 'VIEW'}
						showSearch
						style={{ width: '100%', height: '32px', borderRadius: '4px' }}
						filterOption={true}
						placeholder="Select from the list"
						optionFilterProp="children"
					>
						{constantFormValues?.leaseType?.options?.map(({ key, value, label }) => (
							<Select.Option key={key} value={value}>
								{label}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
			</Col> */}

			<Col xs={4}>
				<InputLabel label={constantFormValues?.leaseTitle?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.leaseTitle?.key} rules={constantFormValues?.leaseTitle?.rules}>
					<Input disabled={screen === 'VIEW'} placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>

			<Col xs={4}>
				<InputLabel label={constantFormValues?.lessorName?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.lessorName?.key} rules={constantFormValues?.lessorName?.rules}>
					<Input disabled={screen === 'VIEW'} placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>

			<Col xs={4}>
				<InputLabel label={constantFormValues?.leaseTerm?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.leaseTerm?.key} rules={constantFormValues?.leaseTerm?.rules}>
					<Input
						type="number"
						disabled
						placeholder="Write here"
						style={{ height: '32px', borderRadius: '4px' }}
						onChange={() => {
							handleLeaseDateChangeD();
						}}
					/>
				</Form.Item>
			</Col>
			<Col xs={4}>
				<InputLabel label={constantFormValues?.leaseEndDate?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.leaseEndDate?.key} rules={constantFormValues?.leaseEndDate?.rules}>
					<DatePicker disabled value={LeaseEndDate} style={{ width: '100%', height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>

			{/* <Col xs={4}>
				<InputLabel label={constantFormValues?.paymentModality?.label} head={true} />
			</Col> */}
			{/* <Col xs={8}> */}
			<Form.Item noStyle name={constantFormValues?.paymentModality?.key} />
			{/* <Select
						disabled={screen === 'VIEW'}
						showSearch
						style={{ width: '100%', height: '32px', borderRadius: '4px' }}
						filterOption={true}
						placeholder="Select from the list"
					>
						{constantFormValues?.paymentModality?.options?.map(({ key, value, label }) => (
							<Select.Option key={key} value={value}>
								{label}
							</Select.Option>
						))}
					</Select>
			</Form.Item>*/}

			{/* </Col> */}

			{screen !== 'CREATE' && (
				<>
					<Col xs={4}>
						<InputLabel label={constantFormValues?.creationDate?.label} head={true} />
					</Col>
					<Col xs={8}>
						<Form.Item name={constantFormValues?.creationDate?.key}>
							<DatePicker
								type="date"
								disabled={screen === 'VIEW' || screen === 'EDIT'}
								format="YYYY-MM-DD"
								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
							/>
						</Form.Item>
					</Col>
					<Col xs={4}>
						<InputLabel label={constantFormValues?.lastModifiedDate?.label} head={true} />
					</Col>
					<Col xs={8}>
						<Form.Item
							name={constantFormValues?.lastModifiedDate?.key}
							initialValue={statusData?.lastModifiedDate ? dayjs(statusData?.lastModifiedDate) : null}
						>
							<DatePicker
								disabled={screen === 'VIEW' || screen === 'EDIT'}
								format="YYYY-MM-DD"
								style={{ width: '100%', height: '32px', borderRadius: '4px' }}
								showTime={false}
							/>
						</Form.Item>
					</Col>
				</>
			)}

			<Col xs={4}>
				<InputLabel label={constantFormValues?.leaseType?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.leaseType?.key} rules={constantFormValues?.leaseType?.rules}>
					<Select
						disabled={screen === 'VIEW'}
						showSearch
						style={{ width: '100%', height: '32px', borderRadius: '4px' }}
						filterOption={true}
						placeholder="Select from the list"
						optionFilterProp="children"
					>
						{constantFormValues?.leaseType?.options?.map(({ key, value, label }) => (
							<Select.Option key={key} value={value}>
								{label}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
			</Col>

			<Col xs={4}>
				<InputLabel label={constantFormValues?.initialDiscountRate?.label} head={true} />
			</Col>
			<Col xs={8}>
				<Form.Item name={constantFormValues?.initialDiscountRate?.key} rules={constantFormValues?.initialDiscountRate?.rules}>
					<Input disabled={screen === 'VIEW'} placeholder="Write here" style={{ height: '32px', borderRadius: '4px' }} />
				</Form.Item>
			</Col>
		</Row>
	);
};

export default GeneralLeaseInformation;
